import React, { useRef, useState } from 'react';
import { Spin } from 'antd';
import { CoffeeOutlined } from '@ant-design/icons';

import config from '../../../config';
import DrinkItem from './DrinkItem';

import './DrinkSelector.less';

const DrinkSelector = ({ selectedDrink: initialSelected, onContinue, drinks = [], loading = false, onSelectDrink }) => {
	const [selectedDrink, setSelectedDrink] = useState(initialSelected);

	useState(() => {
		if (initialSelected && initialSelected?.drink_id)
			setSelectedDrink(initialSelected.drink_id);
		else {
			setSelectedDrink(null);
		}
	}, []);

	const handleDrinkClick = (drink) => {
		if (drink === null) {
			setSelectedDrink(null);
		} else if (drink.isFull) {
			// Prevent selecting sold out drinks
			return;
		} else {
			setSelectedDrink(drink.drink_id);

			if (onSelectDrink)
				onSelectDrink(drink.drink_id);
		}
	};

	const handleContinue = () => {
		const selected = drinks.find(d => d.drink_id === selectedDrink);

		onContinue(selected);
	};

	if (loading) {
		return (
			<div className="drink-selector">
				<div className="drink-loading">
					<Spin size="large" />
					<p>Loading available drinks...</p>
				</div>
			</div>
		);
	}

	if (drinks.length === 0) {
		return (
			<div className="drink-selector">
				<div className="drink-header">
					<CoffeeOutlined className="drink-icon" />
					<h2 className="drink-title">選擇飲品 Select a Drink</h2>
					<p className="drink-subtitle">暫無飲品選擇　No drinks available</p>
				</div>
			</div>
		);
	}

	// Group drinks by category
	const hotDrinks = drinks.filter(d => d.drink_category === 'hot');
	const coldDrinks = drinks.filter(d => d.drink_category === 'cold');

	return (
		<div className="drink-selector">
			<div className="drink-header">
				<CoffeeOutlined className="drink-icon" />
				<h2 className="drink-title">選擇飲品 Select a Drink</h2>
				<p className="drink-subtitle">選擇您的飲品（可選）<br />Choose your beverage (optional)</p>
			</div>

			<div className="drink-sections">
				{/* No Drink Option */}
				<div className="drink-category">
					<div className="drink-list">
						<DrinkItem
							drink={{
								_id: 'no-drink',
								name: '無飲品 No Drink',
								price: 0,
								image: null
							}}
							isSelected={selectedDrink === null}
							onClick={() => handleDrinkClick(null)}
						/>
					</div>
				</div>
				{/* Hot Drinks */}
				{hotDrinks.length > 0 && (
					<div className="drink-category">
						<h3 className="drink-category-title">熱飲 Hot Drinks</h3>
						<div className="drink-list">
							{hotDrinks.map((drink) => {
								// Construct image URL
								let imageUrl = null;
								if (drink?.asset && drink?.asset.uuid && drink?.asset.token) {
									imageUrl = `${config.api}/app/assets/id?uuid=${drink?.asset.uuid}&token=${drink?.asset.token}`;
								}

								return (
									<DrinkItem
										key={drink.drink_id}
										drink={{
											_id: drink.drink_id,
											name: drink.drink_name,
											description: drink?.drink_description,
											price: drink.drink_price,
											image: imageUrl,
											soldOut: drink.isFull
										}}
										isSelected={selectedDrink === drink.drink_id}
										onClick={() => handleDrinkClick(drink)}
										isSoldOut={drink.isFull}
										title={drink.drink_name}
									/>
								);
							})}
						</div>
					</div>
				)}

				{/* Cold Drinks */}
				{coldDrinks.length > 0 && (
					<div className="drink-category">
						<h3 className="drink-category-title">冷飲 Cold Drinks</h3>
						<div className="drink-list">
							{coldDrinks.map((drink) => {
								// Construct image URL
								let imageUrl = null;
								if (drink.asset && drink.asset.uuid && drink.asset.token) {
									imageUrl = `${config.api}/app/assets/id?uuid=${drink.asset.uuid}&token=${drink.asset.token}`;
								}

								return (
									<DrinkItem
										key={drink._id}
										drink={{
											_id: drink.drink_id,
											name: drink.drink_name,
											description: drink.drink_description,
											price: drink.drink_price,
											image: imageUrl,
											soldOut: drink.isFull
										}}
										isSelected={selectedDrink === drink.drink_id}
										onClick={() => handleDrinkClick(drink)}
										isSoldOut={drink.isFull}
									/>
								);
							})}
						</div>
					</div>
				)}
			</div>

			<div className="drink-footer">
				<button
					className="drink-continue-btn"
					onClick={handleContinue}
					disabled={selectedDrink === undefined}
				>
					下一步 Continue
				</button>
			</div>
		</div>
	);
};

export default DrinkSelector;
